module.exports = __webpack_public_path__ + "media/images/undraw/shift/push_notifications-308dba0e917b144915068f88e0570a21.png";